import { createFileRoute } from '@tanstack/react-router'
import { AnalyticsTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/analytics-tab'
import { useStoreProjectModalTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/modal-tab-context'

export const Route = createFileRoute(
  '/_authenticated/development/real-estate/kanban/$cardId/analytics',
)({
  component: AnalyticsTabRoute,
})

function AnalyticsTabRoute() {
  const tab = useStoreProjectModalTab()
  return <AnalyticsTab project={tab.project} canEdit={tab.canEdit} />
}
